import axios from '../utils/axios';

const AYSService = {

    // ── Questions ──────────────────────────────────────────────────────────────
    getQuestions()              { return axios.get('ays/questions'); },
    saveQuestion(data)          { return axios.post('ays/questions/save', data); },
    deleteQuestion(id)          { return axios.post(`ays/questions/delete/${id}`); },
    reorderQuestions(orders)    { return axios.post('ays/questions/reorder', { orders }); },

    // ── Facility enrolment ─────────────────────────────────────────────────────
    getFacilities()             { return axios.get('ays/facilities'); },
    saveFacility(data)          { return axios.post('ays/facilities/save', data); },
    removeFacility(id)          { return axios.post('ays/facilities/remove', { id }); },
    getMyFacility()             { return axios.get('ays/my-facility'); },

    // ── Assessments ────────────────────────────────────────────────────────────
    getAssessments(params = {}) { return axios.get('ays/assessments', { params }); },
    getAssessmentDetail(id)     { return axios.get(`ays/assessments/${id}`); },
    saveAssessment(data)        { return axios.post('ays/assessments/save', data); },
    submitAssessment(id)        { return axios.post(`ays/assessments/${id}/submit`); },
    approveAssessment(id)       { return axios.post(`ays/assessments/${id}/approve`); },
    rejectAssessment(id, reason){ return axios.post(`ays/assessments/${id}/reject`, { reason }); },

    // ── Responses ──────────────────────────────────────────────────────────────
    getResponses(assessmentId)  { return axios.get(`ays/assessments/${assessmentId}/responses`); },
    saveResponses(assessmentId, responses) {
        return axios.post(`ays/assessments/${assessmentId}/responses/save`, { responses });
    },

    // ── Analytics ──────────────────────────────────────────────────────────────
    getAnalytics(params = {})    { return axios.get('ays/analytics', { params }); },
    getQuestionHeatmap: (p={}) => axios.get('ays/heatmap', {params:p}),
    getFacilityTrend: (p={}) => axios.get('ays/trend', {params:p}),
    getSubmissionCompliance: (p={}) => axios.get('ays/compliance', {params:p}),
    getNationalBenchmark(params = {}) { return axios.get('ays/analytics/benchmark', { params }); },

    // ── Health Awards — Categories ─────────────────────────────────────────────
    getHaCategories()            { return axios.get('ays/ha/categories'); },

    // ── Health Awards — Assessments ────────────────────────────────────────────
    getHaAssessments(params = {})    { return axios.get('ays/ha/assessments', { params }); },
    getHaAllAssessments(params = {}) { return axios.get('ays/ha/assessments/all', { params }); },
    getHaAssessmentMEs(params = {})  { return axios.get('ays/ha/assessments/mes', { params }); },
    sendToJudges(assessmentId)       { return axios.post('ays/ha/assessments/send-to-judges', { assessment_id: assessmentId }); },
    finaliseAwards(periodLabel)      { return axios.post('ays/ha/assessments/finalise', { period_label: periodLabel }); },

    // ── Health Awards — Judge Scoring ──────────────────────────────────────────
    getJudgeScores(params = {})  { return axios.get('ays/ha/judge-scores', { params }); },
    saveJudgeScores(data)        { return axios.post('ays/ha/judge-scores/save', data); },

    // ── Health Awards — Consolidated Scores ───────────────────────────────────
    getConsolidatedScores(params = {}) { return axios.get('ays/ha/consolidated-scores', { params }); },
};

export default AYSService;